import { Box, Chip, Skeleton, Typography } from '@mui/material';
import { Show } from '@refinedev/mui';

import useCurrentResource from '../../hooks/useCurrentResource';
import { ThreatInformedDefense } from '../../types';

const ThreatInformedDefenseShow = () => {
  const {
    data: tidContent,
    query: { isLoading }
  } = useCurrentResource<ThreatInformedDefense>();

  return (
    <Show>
      {isLoading ? (
        <Skeleton width={600} height={400} variant="rectangular" />
      ) : (
        <Box
          sx={{
            backgroundImage: `url(${tidContent?.cover_image})`,
            minHeight: 500,
            width: 600,
            backgroundSize: 'cover',
            p: 2
          }}
        >
          <Box sx={{ bgcolor: '#000000b3', p: 2 }} bgcolor="black">
            <Typography variant="h5">{tidContent?.title}</Typography>
            <Typography sx={{ mt: 2 }}>{tidContent?.description}</Typography>{' '}
            {tidContent?.highlight && <Chip sx={{ mt: 2 }} label="Highlight" color="secondary" />}
          </Box>
        </Box>
      )}
    </Show>
  );
};

export default ThreatInformedDefenseShow;
